module.exports = __webpack_public_path__ + "img/496-a18f9c.png";